import { COLORS } from '@enums/colors'
import styled from 'styled-components'
import { device } from '@util/breakpoints'
import { spacing } from '@util/spacing'

type LinkProps = {
  color?: COLORS
}

const defaultProps: LinkProps = {
  color: COLORS.black,
}

const Link = styled.a`
  color: ${(props) => props.color};
  text-decoration: none;
  line-height: 2.625rem;
  text-align: center;
  margin: 0 0 ${spacing.s8} 0;
  cursor: pointer;
  @media ${device.tablet} {
    margin: 0 ${spacing.s8};
  }
`

Link.defaultProps = defaultProps

export default Link
